module.exports = __webpack_public_path__ + "static/media/rfid3.d9a00bf0.jpg";